<template>
  <b-card no-body class="mx-6">
    <b-table striped hover :fields="fields" :items="details"></b-table>
  </b-card>
</template>

<script>
  import * as _ from "lodash";

  export default {
    name: "VPARowDetail",
    props: {
      details: {
        required: true,
        type: Array
      }
    },
    data() {
      return {
        fields: [
          {
            key: "message_id",
            label: "Transaction ID",
            sortable: true
          },
          {
            key: "request_date_time",
            label: "Sent Date",
            sortable: true,
            formatter: value => {
              return new Date(value).toLocaleString();
            }
          },
          {
            key: "status_text",
            label: "Status",
            sortable: true,
            formatter: value => {
              var status = _.find(this.statuses, { value: value });
              if (status) {
                return status.text;
              }
              return value;
            }
          },
          {
            key: "sub_status_text",
            label: "Status Description",
            sortable: true,
            formatter: value => {
              var status = _.find(this.statuses, { value: value });
              if (status) {
                return status.text;
              }
              return value;
            }
          },
          {
            key: "retry_attempt_count",
            label: "Attempt",
            sortable: true,
            formatter: value => {
              if (value) {
                return value + 1;
              }
              return 1;
            }
          }
        ],
        statuses: [
          { text: "Not Sent", value: "NotSent", type: "status" },
          { text: "Sent", value: "Sent", type: "status" },
          { text: "Delivery Failure", value: "DeliveryFailure", type: "status" },
          {
            text: "Response Received",
            value: "ResponseReceived",
            type: "status"
          },
          { text: "Response Failure", value: "ResponseFailure", type: "status" },
          { text: "PA Approved", value: "PAApproved", type: "substatus" },
          { text: "PA Denied", value: "PADenied", type: "substatus" }
        ]
      };
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VPARowDetail.vue